import { Card, CardContent, CircularProgress, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Tooltip, Typography } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import axios from "src/utils/axios";
import { getUser, openBlob } from 'src/utils/Common';
import YouTubeIcon from '@material-ui/icons/YouTube';

const useStyles = makeStyles((theme) => ({
  root: {},
  value: {
    fontWeight: theme.typography.fontWeightMedium
  },
  type: {
    fontWeight: theme.typography.fontWeightMedium
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  searchButton: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  }
}));


function BultenDetay({ className, BultenDetay, Loading, setLoading }) {
  const classes = useStyles();
  const SessionUser = getUser();

  const BultenAc = (log) => {

    setLoading(true);
    const data = {
      BIRIM_KODU: SessionUser.ServiceShopId.toString(),
      SICIL_NO: SessionUser.UserId,
      FilePtr: log.FP,
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/FileImportExport/ArtemisBulten', data, config)
      .then(response => {
        openBlob(response.data, log.BT + '_' + log.AY + '_' + log.BN);
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      })
  };
  const BultenVideoAc = (event,log) => {
    event.persist();
    window.open(log.Video);
    event.persist();
  };
  

  return (
    <div>
      <Card className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              {Loading ?
                <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }}
                />
                :
                Array.isArray(BultenDetay) && BultenDetay?.map(log => (
                  <List className={classes.root} key={log.BN}>
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar key={log.BN}>
                        <Typography
                          component="span"
                          variant="h3"
                          className={classes.inline}
                          color="textPrimary">{log.GUN}</Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className={classes.inline}
                          color="textPrimary">{log.AY}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className={classes.inline}
                          color="textPrimary">{log.YIL}
                        </Typography>
                        <br></br>
                      </ListItemAvatar>
                      <ListItemText
                        primary={log.BT}
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="body2"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {log.A}
                              <br />
                              {
                                log.Video ? <YouTubeIcon onClick={(event) => BultenVideoAc(event,log)} style={{color:"#ff0000"}} />
                                : ""
                              }
                              
                             
                            </Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction>
                        <Tooltip title="Bülten Göster">
                          <IconButton
                            color="primary"
                            edge="end"
                            onClick={() => BultenAc(log)}
                            size="small">
                            <CloudDownloadIcon />
                          </IconButton>
                        </Tooltip>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </List>
                ))}
            </div>
          </PerfectScrollbar>
        </CardContent>
      </Card>
    </div>
  );
}

BultenDetay.propTypes = {
  className: PropTypes.string
};

export default BultenDetay;
